export default {
	namespaced: true,
	state: {
		products: [],
		services: [],
		requirements: [],
		loanPayStyle: [],
		loans: {}
	},

	mutations:{
		/**
		 * [removeLoan description]
		 * @param  {[type]} state              [description]
		 * @param  {[type]} options.product_id [description]
		 * @param  {[type]} options.loan_id    [description]
		 * @return {[type]}                    [description]
		 */
		removeLoan(state, {product_id, loan_id}) {
			// console.log(product_id, loan_id)
			if(state.loans[product_id]) {
				for(let i=0; i<state.loans[product_id].length; i++) {
					if(state.loans[product_id][i].id==loan_id) {
						state.loans[product_id].splice(i, 1)
					}
				}
			}
		},

		/**
		 * [updateLoan description]
		 * @param  {[type]} state      [description]
		 * @param  {[type]} product_id [description]
		 * @param  {[type]} loan       [description]
		 * @return {[type]}            [description]
		 */
		updateLoan(state, {product_id, loan}) {
			if(state.loans[product_id]) {
				for(let i=0; i<state.loans[product_id].length; i++) {
					if(state.loans[product_id][i].id==loan.id) {
						state.loans[product_id][i]=loan
					}
				}
			}
		},

		/**
		 * [addLoan description]
		 * @param {[type]} state              [description]
		 * @param {[type]} options.product_id [description]
		 * @param {[type]} options.loan       [description]
		 */
		addLoan(state, {product_id, loan}) {
			if(!state.loans[product_id]) {
				state.loans[product_id]=[]
			}
			state.loans[product_id].push(loan)
		},

		/**
		 * [setLoans description]
		 * @param {[type]} state [description]
		 */
		setLoans(state, {product_id, loans}) {
			state.loans[product_id]=loans
		},

		/**
		 * [setLoanPayStyle description]
		 * @param {[type]} state         [description]
		 * @param {[type]} loanPayStyles [description]
		 */
		setLoanPayStyle(state, loanPayStyles) {
			state.loanPayStyle= loanPayStyles
		},

		/**
		 * [setRequirements description]
		 * @param {[type]} state   [description]
		 * @param {[type]} payload [description]
		 */
		setRequirements(state, payload) {
			state.requirements = payload
		},

		/**
		 * [removeProduct description]
		 * @param  {[type]} state      [description]
		 * @param  {[type]} product_id [description]
		 * @return {[type]}            [description]
		 */
		removeProduct(state, product_id) {
			for(let i=0; i<state.products.length; i++) {
				if(state.products[i].id==product_id) {
					state.products.splice(i, 1);
					break
				}
			}
		},

		/**
		 * [setList description]
		 * @param {[type]} state   [description]
		 * @param {[type]} payload [description]
		 */
		setProducts(state, payload) {
			state.products = payload
		},

		/**
		 * [updateProduct description]
		 * @param  {[type]} state   [description]
		 * @param  {[type]} payload [description]
		 * @return {[type]}         [description]
		 */
		updateProduct(state, product) {
			for(let i=0; i<state.products.length; i++) {
				if(state.products[i].id==product.id) {
					state.products[i]=product
					break
				}
			}
		},

		/**
		 * [addList description]
		 * @param {[type]} state   [description]
		 * @param {[type]} payload [description]
		 */
		addProduct(state, payload) {
			state.products.push(payload)
		},

		/**
		 * [setServices description]
		 * @param {[type]} state   [description]
		 * @param {[type]} payload [description]
		 */
		setServices(state, payload) {
			state.services=payload
		}
	},
	getters:{
		/**
		 * [loans description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		loans(state) {
			return (product_id) => {
				return state.loans[product_id]||[]
			}
		},

		/**
		 * [loanPayStyle description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		loanPayStyle(state) {
			return state.loanPayStyle
		},

		/**
		 * [requirements description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		requirements(state) {
			return state.requirements
		},

		/**
		 * [services description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		services(state) {
			return state.services
		},

		/**
		 * [products description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		products(state) {
			return state.products
		}
	},
	actions: {
		/**
		 * [removeLoan description]
		 * @param  {[type]} options.commit [description]
		 * @param  {[type]} options.state  [description]
		 * @param  {[type]} loan_id        [description]
		 * @return {[type]}                [description]
		 */
		removeLoan({commit, state}, {product_id, loan_id}) {
			return this._vm.$http.delete('products-and-services/loans/'+loan_id)
				.then(response => {
					commit('removeLoan', {product_id, loan_id})
				})
		},

		/**
		 * [updateLoan description]
		 * @param  {[type]} options.commit     [description]
		 * @param  {[type]} options.state      [description]
		 * @param  {[type]} options.product_id [description]
		 * @param  {[type]} options.loan       [description]
		 * @return {[type]}                    [description]
		 */
		updateLoan({commit, state}, {product_id, loan}) {
			return this._vm.$http.post('products-and-services/loans/'+product_id+'/'+loan.id, loan)
				.then(response => {
					commit('updateLoan', {product_id: product_id, loan: response.data})
					return response.data
				})
		},

		/**
		 * [createLoan description]
		 * @param  {[type]} options.commit     [description]
		 * @param  {[type]} options.state      [description]
		 * @param  {[type]} options.product_id [description]
		 * @param  {[type]} options.loan       [description]
		 * @return {[type]}                    [description]
		 */
		createLoan({commit, state}, {product_id, loan}) {
			return this._vm.$http.post('products-and-services/loans/'+product_id, loan)
				.then(response => {
					commit('addLoan', {product_id: product_id, loan: response.data})
					return response.data
				})
		},

		/**
		 * [getLoans description]
		 * @param  {[type]} options.commit [description]
		 * @param  {[type]} options.state  [description]
		 * @param  {[type]} product_id     [description]
		 * @return {[type]}                [description]
		 */
		getLoans({commit, state}, product_id) {
			return this._vm.$http.get('products-and-services/loans/'+product_id)
				.then(response => {
					commit('setLoans', {product_id: product_id, loans: response.data})
					return response.data
				})
		},

		/**
		 * [getLoanPayStyles description]
		 * @param  {[type]} options.commit [description]
		 * @param  {[type]} options.state  [description]
		 * @return {[type]}                [description]
		 */
		getLoanPayStyles({commit, state}) {
			if(state.loanPayStyle.length) {
				return Promise.resolve(state.loanPayStyle)
			}

			return this._vm.$http.get('products-and-services/loan-pay-styles')
				.then(response => {
					commit('setLoanPayStyle', response.data)
					return response.data
				})
		},

		/**
		 * [removeProduct description]
		 * @param  {[type]} options.commit [description]
		 * @param  {[type]} options.state  [description]
		 * @param  {[type]} product_id     [description]
		 * @return {[type]}                [description]
		 */
		removeProduct({commit, state}, product_id) {
			return this._vm.$http.delete('products-and-services/products/'+product_id)
				.then(response => {
					commit('removeProduct', product_id)
					return response.data
				})
		},

		/**
		 * [fetchProducts description]
		 * @param  {[type]} options.commit [description]
		 * @param  {[type]} options.state  [description]
		 * @return {[type]}                [description]
		 */
		fetchProducts({commit, state}) {
			if(state.products.length) {
				return Promise.resolve(state.products)
			}
			return this._vm.$http.get('products-and-services/products')
				.then(response => {
					commit('setProducts', response.data)
					return response.data
				})
		},

		/**
		 * [savePost description]
		 * @param  {[type]} options.commit [description]
		 * @param  {[type]} options.state  [description]
		 * @param  {[type]} form           [description]
		 * @return {[type]}                [description]
		 */
		saveProduct({commit, state}, {form, product_id}) {
			return this._vm.$http.post('products-and-services/products'+(product_id?'/'+product_id:''), form)
				.then(response => {
					if(product_id) {
						commit('updateProduct', response.data)
					} else {
						commit('addProduct', response.data)
					}
					return response.data
				})
		},

		/**
		 * [fetchRequirements description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @return {[type]}                 [description]
		 */
		fetchRequirements({commit, state}) {
			if(state.requirements.length) {
				return Promise.resolve(state.requirements)
			} else {
				return this._vm.$http.get('products-and-services/requirements')
					.then(response => {
						commit('setRequirements', response.data)
						return response.data
					})
			}
		},

		/**
		 * [fetchServices description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @return {[type]}                 [description]
		 */
		fetchServices({commit, state}) {
			if(state.services.length) {
				return Promise.resolve(state.services)
			} else {
				return this._vm.$http.get('products-and-services/services')
				.then(response => {
					commit('setServices', response.data)
					return response.data
				})
			}
			// return 
		}
	},

}